import React from "react";
import Portfolio from "./components/Dev/Portfolio";
import "bootstrap/dist/css/bootstrap.min.css";

// Previous multi-page design (Navbar, Home, About, Resume, particles) is kept
// in src/components and can be restored by swapping this file back.
function App() {
  return <Portfolio />;
}

export default App;
